import { generateId } from '@monoimin/utils/helpers';

/**
 * Simple browser-compatible hash function using djb2 algorithm
 * @param str String to hash
 * @returns Hash as hexadecimal string
 */
function simpleHash(str: string): string {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) + hash + str.charCodeAt(i);
  }
  // Convert to positive number and then to hex
  return Math.abs(hash).toString(16).padStart(8, '0').substring(0, 8);
}

/**
 * Generates a unique event ID for analytics tracking
 * Format: timestamp-randomString-hash
 * @param prefix Optional prefix for the event ID
 * @param seed Optional data to include in hash generation for consistency
 * @returns Unique event ID string
 */
export const generateEventId = (
  prefix = 'evt',
  seed?: Record<string, any>
): string => {
  // Get current timestamp
  const timestamp = Date.now().toString();

  // Generate random component
  const randomPart = generateId(8);

  // Create hash component if seed data is provided for consistency
  let hashPart = '';
  if (seed) {
    // Generate a browser-compatible hash from the seed data
    hashPart = simpleHash(JSON.stringify(seed));
  }

  // Combine components
  return hashPart
    ? `${prefix}_${timestamp}_${randomPart}_${hashPart}`
    : `${prefix}_${timestamp}_${randomPart}`;
};
